import { createContext, useContext } from 'react';
import { AuthUserResponse } from '@/features/auth/services/schemas.ts';

export interface AuthContextValue {
  logout: () => void;
  currentUser: AuthUserResponse;
}

export const AuthContext = createContext<AuthContextValue>(undefined!);

export function useAuth() {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return authContext;
}
